import {  CapacitiesType } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class CapacitiesTypesAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get actor() {
        return capitalizeString(this.value.actor);
    }

    get collectionName() {
        return this.value.collection_name;
    }
    adapt(): CapacitiesType {
        return {
            id: this.value.id,
            contact_email : this.value.contact_email,
            contact_name : this.value.contact_name,
            collection_name: this.value.collection_name,
            name : this.value.capacities || this.value.name,
            typology : this.value.typology,
            type : this.value.type,
            recognized_min : this.value.recognized_min
        };
    }
}
